const initialState = {
    barcode: '', // input
    barcodeBtnDisable: false, 
    fullname: '', 
    nationalCode: '',
    normalCredit: 0, 
    normalCreditNumeric: '', 
    orgCredit: 0,
    orgCreditNumeric: '',
    userCode: '',
    orgTxt: '',
    mobile: '',
};

const userAuthentication = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_INPUT_PAGE_USER_AUTHENTICATION':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default userAuthentication;
